// @flow

import React from 'react';
import { SortableContainer, SortableElement, SortableHandle } from 'react-sortable-hoc';
import arrayMove from 'array-move';
import { isMobile } from '../const';

export const DragHandle = SortableHandle(({ value }) => value);

const SortableItem = SortableElement(({ value }) =>
  (<div>
    {value}
  </div>));

const SortableList = SortableContainer(({ items, className }) => (
  <div className={className}>
    {items.map((value, index) => (
      <SortableItem key={`item-${index}`} index={index} value={value} disabled={isMobile} />
    ))}
  </div>));

type Props = {
  list: React.Node[],
  className: string,
}

type State = {
  keyOrder: { [key: string]: number }
}

class DraggableList extends React.Component<Props, State> {
  state = {
    keyOrder: {},
  };

  onSortEnd = ({ oldIndex, newIndex }) => {
    let i = 0;
    const obj = {};
    arrayMove(this.props.list, oldIndex, newIndex).forEach((key) => {
      i += 1;
      obj[key.key] = i;
    });
    this.setState({ keyOrder: obj });
  };

  render() {
    return (
      <SortableList
        axis="x"
        lockAxis="x"
        items={
          this.props.list.sort((a, b) => this.state.keyOrder[a.key] - this.state.keyOrder[b.key])
        }
        className={this.props.className}
        onSortEnd={this.onSortEnd}
        useDragHandle
      />
    );
  }
}

export default DraggableList;
